import { requestLandingMain } from "../apis/landing_api";
const state = {
  landingFaqList: [],
  landingNoticeList: []
};

const getters = {
  getLandingFaqList(state) {
    return state.landingFaqList;
  },
  getLandingNoticeList(state) {
    return state.landingNoticeList;
  }
};

const mutations = {
  SET_FAQ_LIST(state, payload) {
    state.landingFaqList = payload;
  },

  SET_NOTICE_LIST(state, payload) {
    state.landingNoticeList = payload;
  }
};

const actions = {
  async REQUEST_LANDING({ commit }) {
    try {
      commit("START_LOADING");

      const response = await requestLandingMain();
      const { data } = response;

      const { resultFaqList, resultNoticeList } = data;

      commit("SET_FAQ_LIST", resultFaqList);
      commit("SET_NOTICE_LIST", resultNoticeList);
    } catch (e) {
      console.error(e);
      alert(
        "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
      );
    } finally {
      commit("END_LOADING");
    }
  }
};

export default { mutations, state, actions, getters };
